export default "__VITE_ASSET__CfXkKdRl__"